"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IcdCodeSearch = void 0;
require("antd/lib/auto-complete/style");
var _autoComplete = _interopRequireDefault(require("antd/lib/auto-complete"));
var _react = _interopRequireWildcard(require("react"));
var _lodash = require("lodash");
var _classnames = _interopRequireDefault(require("classnames"));
var _components = require("../../components");
var _utils = require("../../utils");
require("./IcdCodeSearch.less");
var _excluded = ["disabled", "id", "onChange"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
var formatOptions = function formatOptions(codes, searchInput) {
  var options = !searchInput.length ? [/*#__PURE__*/_react.default.createElement(_autoComplete.default.Option, {
    key: "navigation",
    disabled: true,
    className: "navigation"
  }, "eg. Alcohol abuse, F10")] : codes.length ? codes.map(function (code) {
    return /*#__PURE__*/_react.default.createElement(_autoComplete.default.Option, {
      key: code,
      value: code
    }, code);
  }) : [/*#__PURE__*/_react.default.createElement(_autoComplete.default.Option, {
    key: "navigation",
    disabled: true,
    className: "navigation"
  }, "No results found")];
  return options;
};
var IcdCodeSearch = function IcdCodeSearch(_ref) {
  var disabled = _ref.disabled,
    id = _ref.id,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? _lodash.noop : _ref$onChange,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useInputValidation = (0, _utils.useInputValidation)(_objectSpread(_objectSpread({}, props), {}, {
      alwaysShowError: true
    })),
    error = _useInputValidation.error;
  var value = props.value;
  var selectedCodes = (0, _lodash.compact)(value) || [];
  var _useState = (0, _react.useState)(''),
    _useState2 = _slicedToArray(_useState, 2),
    searchInput = _useState2[0],
    setSearchInput = _useState2[1];
  var _useRequest = (0, _utils.useRequest)((0, _utils.getSearchIcdCodeUrl)({
      query: searchInput
    }), {
      debounceWait: 300,
      refreshDeps: [searchInput]
    }),
    _useRequest$data = _useRequest.data,
    icdCodes = _useRequest$data === void 0 ? [] : _useRequest$data;
  var allCodes = (0, _react.useMemo)(function () {
    return icdCodes.map(function (code) {
      return code.text;
    });
  }, [icdCodes]);
  var handleAddIcdCode = function handleAddIcdCode(codeText) {
    var newIcdCodes = _toConsumableArray(selectedCodes);
    // Don't add duplicate codes
    if (newIcdCodes.find(function (code) {
      return code === codeText;
    })) {
      return;
    }
    newIcdCodes.push(codeText);
    onChange(newIcdCodes);
  };
  var handleDeleteIcdCode = function handleDeleteIcdCode(codeText) {
    onChange((0, _lodash.without)(selectedCodes, codeText));
  };
  var handleSelect = function handleSelect(value) {
    // Clear search on select code
    setSearchInput('');
    handleAddIcdCode(value);
  };
  var handleSearch = function handleSearch(value) {
    setSearchInput(value || '');
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "flex flex-col gap-y-[16px]"
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_autoComplete.default, {
    style: {
      width: '100%'
    },
    className: "icd-code-search",
    dropdownClassName: "icd-code-search-dropdown",
    dropdownMatchSelectWidth: true,
    size: "large",
    dataSource: formatOptions(allCodes, searchInput),
    backfill: false,
    onSelect: handleSelect,
    onSearch: handleSearch,
    value: searchInput,
    disabled: disabled,
    id: id
  }, /*#__PURE__*/_react.default.createElement(_components.TextInput, {
    contained: true,
    placeholder: "Search ICD codes or keywords",
    icon: "search-24",
    iconPosition: "right"
  })), error && /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)('text-alertred-60 tw-caption-regular inline-block', 'pointer-events-none',
    // Used to animate description appearance
    error ? 'mt-[6px] h-[17px]' : 'mt-0 h-0', error ? 'opacity-100' : 'opacity-0')
  }, error)), selectedCodes.map(function (code) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: code,
      className: "border border-solid border-green1-50 rounded-[4px] px-[10px] py-[8px] flex justify-between items-center"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "tw-body-sm-light text-black"
    }, code), !disabled && /*#__PURE__*/_react.default.createElement(_components.IconButton, {
      icon: "close-24",
      size: "large",
      className: "text-green1-50 ml-[10px]",
      onClick: function onClick() {
        return handleDeleteIcdCode(code);
      }
    }));
  }));
};
exports.IcdCodeSearch = IcdCodeSearch;